import { render, staticRenderFns } from "./McrFooter.vue?vue&type=template&id=03ce1baa"
import script from "./McrFooter.vue?vue&type=script&lang=js"
export * from "./McrFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports